import { render } from "./AwardsSlider.vue?vue&type=template&id=70d112f4&scoped=true"
import script from "./AwardsSlider.vue?vue&type=script&lang=js"
export * from "./AwardsSlider.vue?vue&type=script&lang=js"

import "./AwardsSlider.vue?vue&type=style&index=0&id=70d112f4&scoped=true&lang=scss"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/Whappy1/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d112f4"]])

export default __exports__